// src/components/TestimoniCard/TestimoniCard.js
import React from 'react';
import './TestimoniCard.scss';
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';

const TestimoniCard = ({ img, name, description, rating, profile }) => {
  const maxStars = 5;
  const fullStars = Math.round(rating || 0);

  return (
    <div className="col-lg-4 single-testimoni">
      <div className="testimonial-card">
        <div className="testimonial-img">
          {img ? (
            <img src={img} alt={name} />
          ) : profile ? (
            <div className="testimonial-initials">{profile}</div>
          ) : null}
        </div>
        <div className="testimonial-text">
          <h3>{name}</h3>
          <p>{description}</p>
        </div>
        <ul className="testimonial-rating">
          {Array.from({ length: maxStars }, (_, i) => (
            <li key={i} className={i < fullStars ? 'filled' : 'empty'}>
              {i < fullStars ? <AiFillStar /> : <AiOutlineStar />}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TestimoniCard;
